import { observable, configure, action } from 'mobx';
import util from 'preact-util';
import LocalModel from './localModel';

configure({ enforceActions: 'always' });

class SupportAiChatStore extends LocalModel {
    constructor() {
        super('supportAiChat', {
            namePlural: 'supportAiChats',
            namePluralReal: 'supportAiChats',
            api: {},
        });
    }

    @observable conversationUuidv4 = null;
    @observable messages = [];
    @observable loading = false;
    @observable lastError = null;
    @observable truncated = false;

    @action
    newConversation() {
        this.updateKeyValue('conversationUuidv4', null);
        this.updateKeyValue('messages', []);
        this.updateKeyValue('lastError', null);
        this.updateKeyValue('truncated', false);
    }

    @action
    async sendPrompt(prompt, scope) {
        const trimmed = (prompt || '').trim();
        if (!trimmed) return;

        const next = (this.messages || []).slice();
        next.push({ role: 'user', text: trimmed });
        this.updateKeyValue('messages', next);
        this.updateKeyValue('loading', true);
        this.updateKeyValue('lastError', null);

        try {
            const response = await util.fetchApi('/api/ai/staff-chat', { method: 'POST' }, {
                conversationUuidv4: this.conversationUuidv4,
                prompt: trimmed,
                scope: {
                    showAll: !!(scope && scope.showAll),
                    customerId: scope && scope.customerId != null ? scope.customerId : null,
                },
            });

            if (response && response.status === 200 && response.data) {
                this.updateKeyValue('conversationUuidv4', response.data.conversationUuidv4);
                this.updateKeyValue('truncated', !!response.data.truncated);
                const updated = (this.messages || []).slice();
                updated.push({
                    role: 'assistant',
                    text: response.data.answer || '',
                    toolCalls: response.data.toolCalls || [],
                });
                this.updateKeyValue('messages', updated);
            } else {
                this.updateKeyValue('lastError', (response && response.message) || 'Request failed.');
            }
        } catch (err) {
            this.updateKeyValue('lastError', err.message || 'Network error.');
        } finally {
            this.updateKeyValue('loading', false);
        }
    }
}

const store = new SupportAiChatStore();
export default store;
